import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { portalId, refreshToken } from '../../constants/leadinConfig';
import ElementorBanner from '../Common/ElementorBanner';
import UISpinner from '../../shared/UIComponents/UISpinner';
import { __ } from '@wordpress/i18n';
import { BackgroudAppContext, useBackgroundAppContext, } from '../../iframe/useBackgroundApp';
import useForms from './hooks/useForms';
import { getOrCreateBackgroundApp } from '../../utils/backgroundAppUtils';
import { isRefreshTokenAvailable } from '../../utils/isRefreshTokenAvailable';
function ElementorFormSelect({ formId, setAttributes, }) {
    const { hasError, forms, loading } = useForms();
    return loading ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : hasError ? (_jsx(ElementorBanner, { type: "danger", children: __('Please refresh your forms or try again in a few minutes', 'leadin') })) : (_jsxs("select", { value: formId, onChange: event => {
            const selectedForm = forms.find(form => form.value === event.target.value);
            if (selectedForm) {
                setAttributes({
                    portalId,
                    formId: selectedForm.value,
                    formName: selectedForm.label,
                    embedVersion: selectedForm.embedVersion,
                });
            }
        }, children: [_jsx("option", { value: "", disabled: true, selected: true, children: __('Search for a form', 'leadin') }), forms.map(form => (_jsx("option", { value: form.value, children: form.label }, form.value)))] }));
}
function ElementorFormSelectWrapper(props) {
    const isBackgroundAppReady = useBackgroundAppContext();
    return (_jsx(Fragment, { children: !isBackgroundAppReady ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : (_jsx(ElementorFormSelect, { ...props })) }));
}
export default function ElementorFormSelectContainer(props) {
    return (_jsx(BackgroudAppContext.Provider, { value: isRefreshTokenAvailable() && getOrCreateBackgroundApp(refreshToken), children: _jsx(ElementorFormSelectWrapper, { ...props }) }));
}
